import React, { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import ApplicationSkeleton from '~/components/ApplicationSkeleton';

const AsyncTurnReportList = lazy(() => import('~/containers/TurnReportList'));

export default [
  <Route path="/turn-reports">
    <Suspense fallback={<ApplicationSkeleton />}>
      <AsyncTurnReportList />
    </Suspense>
  </Route>,
];
